import React from "react";
import * as dc from "dc";
import { ChartTemplate } from "./chartTemplate";
import * as d3 from "d3";
/* 
dc.js template 
*/
const dealoneChartFunc = (divRef, ndx) => {
  //  create dimension by ticket size
    const dimension = ndx.dimension((d) => Math.round(d.ticketSize / 1000));
  const dealCountGrp = dimension.group().reduceCount();

  
  const dealSizeChart = dc.barChart(divRef);
  dealSizeChart
    .width(400) /* dc.barChart('#monthly-volume-chart', 'chartGroup'); */
    .height(55)
    .margins({ top: 0, right: 40, bottom: 35, left: 15 })
    .dimension(dimension)
    .group(dealCountGrp)
    .centerBar(true)
    .gap(1)
    .x(d3.scaleLinear().domain([1000, 60000]))
    .xUnits(dc.units.integers)
    .elasticY(true)
    .xAxisLabel("Value in Dollars(000')")
    .brushOn(true)
    .transitionDuration(0)

    .alwaysUseRounding(true);
  dealSizeChart.yAxis().ticks(0);
  dealSizeChart.xAxis().ticks(6);
  return dealSizeChart;
};

export const DealCatSizeChart = (props) => (
  <ChartTemplate
    chartFunction={dealoneChartFunc}
    title="Investment Opportunities Ticket Sizes (1000 - 60000)" id="dealSize"
  />
);
